import React from 'react'
import styled from 'styled-components'
import Card2 from './Card2'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';

const DetailCard = () => {
   return (
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
               <h3 className="small-heading">
               Building Tech. Building Community.
               </h3>
               <p className="c-para"> What Makes This Training Unique: It integrates coding, design, and 3D creativity, enabling youth to create immersive digital experiences that go beyond traditional websites.</p>
            </div>
            <div className='card-con'>
               <Card2
                  account={'Skills & Tools You’ll Gain'}
                  text={'Build and deploy your own interactive 3D websites or games.'}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Technical Proficiency: Gain hands-on experience with Three.js, R3F, WebGL, JavaScript, and Blender.'}
                  text2={'3D Modeling & Animation: Learn essential techniques in 3D modeling, animation, scene composition, and interactive design.'}
                  text3={'Design 3-dimensional logos, texts and animations, and incorporate them in your own page, application or game.'}
                  text4={'Integration Skills: Develop the ability to incorporate 3D content into real-world web projects, creating engaging and visually dynamic experiences.'}
                  text5={'Portfolio Development: Create visually impressive work that demonstrates technical expertise and creativity.'}
                  text6={'Practical Application: Combine coding, 3D modeling, and design principles into seamless, interactive web experiences.'}
               />
            </div>
         </InnerLayout>
      </PaymentStyled>
   )
}

const PaymentStyled = styled.section`
 .card-con {
    display: flex; /* Use flexbox for centering */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    padding-top: 4rem; /* Adjust top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px; 
    margin: 0 auto;
    width: 100%; /* Ensure it takes full width of the container */
    
    /* Optional: If you want to increase the width of the cards themselves */
    .card2 {
      width: 100%; /* Adjust the width of individual cards */
      max-width: 100%; /* You can set a specific width like 80% or more */
    }

    @media screen and (max-width: 689px) {
      flex-direction: column; /* Stack content on mobile */
    }
  }

  p {
    text-align: center;
  }
`

export default DetailCard
